const findInNested = <T extends { [key: string]: any }>(
  list: T[],
  cb: (item: T) => boolean,
  childrenPropName = 'children'
): T | undefined => {
  let result: T | undefined;

  list.some(item => {
    if (cb(item)) {
      result = item;
      return true;
    }

    const children = item[childrenPropName];
    if (!children) {
      return false;
    }

    const nestedItem = findInNested<T>(children, cb);
    if (nestedItem) {
      result = nestedItem;
      return true;
    }

    return false;
  });

  return result;
};

export default findInNested;
